<template>
  <div class="toastification">
    <div class="flex items-start">
      <div class="avatar placeholder mr-2" :class="variant">
        <div class="flex items-center justify-center rounded-lg border w-8 h-8" :class="`bg-${selectedClass}/25 border-${selectedClass}`">
          <span class="text-xs" :class="`text-${selectedClass}`"><base-feather-icon :icon="icon" size="15" /></span>
        </div>
      </div>
      <div class="flex grow">
        <div class="flex flex-col gap-1">
          <h5 v-if="title" v-text="title" class="toastification-title font-bold uppercase leading-none" :class="`text-${selectedClass}`"/>
          <p v-if="text" class="text-slate-500 leading-none font-light text-xs" v-text="text" />
          <ul v-if="extra.length" class="list-disc list-inside">
            <li v-for="(r, i) in extra" :key="i" class="text-slate-500 leading-none font-light text-xs" v-text="r">
            </li>
          </ul>
        </div>
        <span class="toastification-close-icon cursor-pointer ml-auto text-slate-400" @click.prevent="$emit('close-toast')">
          <base-feather-icon v-if="!hideClose" icon="XIcon" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      default: "primary",
    },
    icon: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    extra: {
      type: Array,
      default: [],
    },
    hideClose: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    selectedClass() {
      return this.colors[this.variant]
    },
  },
  data() {
    return {
      colors: {
        default: '[#3cbab2]',
        success: 'green-500',
        info: 'blue-500',
        warning: 'yellow-500',
        error: 'red-500',
        danger: 'red-500',
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.toastification-close-icon,
.toastification-title {
  line-height: 26px;
}

.toastification-title {
  color: inherit;
}
</style>
